// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/nurse-bg-1.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* === Page Background === */
.apply-nursing-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Keep your background image */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* padding-top: 120px; create space below navbar */
  position: relative;
}

/* translucent overlay on top of image for readability */
.apply-nursing-overlay {
  width: 100%;
  display: flex;
  justify-content: center;
  /* padding: 40px 0; */
  /* background: rgba(255, 255, 255, 0.9); light transparent white overlay */
}

/* === Content Box (centered) === */
.apply-nursing-container {
  /* background: #fff; */
  border-radius: 16px;
  padding: 50px;
  max-width: 850px;
  width: 90%;
  /* box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); */
  text-align: center;
}

/* === Titles === */
.apply-nursing-title {
  font-size: 2.3rem;
  font-weight: 700;
  color: #c01313;
  margin-bottom: 10px;
}

.apply-nursing-title-h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #c01313;
  margin-bottom: 15px;
}

.apply-nursing-intro {
  font-size: 1.05rem;
  color: #333;
  margin-bottom: 35px;
}

.apply-nursing-section-title {
  color: #333;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.apply-nursing-subtitle {
  color: #444;
  font-weight: 600;
  font-size: 1.05rem;
  margin: 25px 0 15px 0;
}

/* === Buttons === */
.apply-nursing-pdf-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-bottom: 35px;
}

.apply-nursing-pdf-btn {
  background: #c01313;
  color: #fff;
  padding: 14px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

.apply-nursing-pdf-btn:hover {
  background: #fe0000;
  transform: translateY(-3px);
}

/* === Cards === */
.apply-nursing-card-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 25px;
  margin-top: 25px;
}

.apply-nursing-card {
  background: #fff;
  border: 2px solid #c01313;
  border-radius: 12px;
  padding: 30px;
  width: 320px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  will-change: transform;
}

.apply-nursing-card h3 {
  color: #c01313;
  font-weight: 700;
  margin-bottom: 10px;
   display: inline-block;   /* keeps the box tight to the text */
  padding: 0.25rem 0.6rem; /* space inside the border */
  border: 1px solid #333;  /* border color/width */
  border-radius: 999px;
}

.apply-nursing-card p {
  color: #333;
  font-size: 0.95rem;
  line-height: 1.5;
}

.apply-nursing-card:hover {
  background: #c01313;
  color: #fff;
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(192, 19, 19, 0.4);
}

.apply-nursing-card:hover h3,
.apply-nursing-card:hover p {
  color: #fff;
}

/* ✅ Non-clickable cards (Step 2 & Step 3) */
.apply-nursing-card--static {
  cursor: default;
}

/* ✅ Floating animation for Step 2 & Step 3 */
@keyframes gentleFloat {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(0);
  }
}

.apply-nursing-card--float {
  animation: gentleFloat 4.2s ease-in-out infinite;
}

/* small stagger so both don't move in sync */
.apply-nursing-card--float-delay {
  animation-delay: 0.6s;
}

/* Keep hover behavior working even while floating */
.apply-nursing-card--float:hover {
  animation-play-state: paused;
}

/* === Note === */
.apply-nursing-note {
  margin-top: 40px;
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
  border-left: 5px solid #fe0000;
  padding: 16px;
  border-radius: 10px;
  font-weight: 500;
  color: #333;
}

/* === Responsive === */
@media (max-width: 768px) {
  .apply-nursing-page {
    padding-top: 100px;
  }

  .apply-nursing-container {
    padding: 30px 20px;
  }

  .apply-nursing-title {
    font-size: 1.8rem;
  }

  .apply-nursing-card {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ApplyNursing.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,yDAAoD,EAAE,+BAA+B;EACrF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,0EAA0E;AAC5E;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,0CAA0C;EAC1C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;GAClB,qBAAqB,IAAI,oCAAoC;EAC9D,uBAAuB,EAAE,4BAA4B;EACrD,sBAAsB,GAAG,uBAAuB;EAChD,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gDAAgD;AAClD;;AAEA,6CAA6C;AAC7C;EACE,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* === Page Background === */\n.apply-nursing-page {\n  background-image: url(\"../../public/nurse-bg-1.jpg\"); /* Keep your background image */\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  /* padding-top: 120px; create space below navbar */\n  position: relative;\n}\n\n/* translucent overlay on top of image for readability */\n.apply-nursing-overlay {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  /* padding: 40px 0; */\n  /* background: rgba(255, 255, 255, 0.9); light transparent white overlay */\n}\n\n/* === Content Box (centered) === */\n.apply-nursing-container {\n  /* background: #fff; */\n  border-radius: 16px;\n  padding: 50px;\n  max-width: 850px;\n  width: 90%;\n  /* box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); */\n  text-align: center;\n}\n\n/* === Titles === */\n.apply-nursing-title {\n  font-size: 2.3rem;\n  font-weight: 700;\n  color: #c01313;\n  margin-bottom: 10px;\n}\n\n.apply-nursing-title-h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #c01313;\n  margin-bottom: 15px;\n}\n\n.apply-nursing-intro {\n  font-size: 1.05rem;\n  color: #333;\n  margin-bottom: 35px;\n}\n\n.apply-nursing-section-title {\n  color: #333;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.apply-nursing-subtitle {\n  color: #444;\n  font-weight: 600;\n  font-size: 1.05rem;\n  margin: 25px 0 15px 0;\n}\n\n/* === Buttons === */\n.apply-nursing-pdf-section {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 35px;\n}\n\n.apply-nursing-pdf-btn {\n  background: #c01313;\n  color: #fff;\n  padding: 14px 30px;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  transition: all 0.3s ease;\n}\n\n.apply-nursing-pdf-btn:hover {\n  background: #fe0000;\n  transform: translateY(-3px);\n}\n\n/* === Cards === */\n.apply-nursing-card-section {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 25px;\n  margin-top: 25px;\n}\n\n.apply-nursing-card {\n  background: #fff;\n  border: 2px solid #c01313;\n  border-radius: 12px;\n  padding: 30px;\n  width: 320px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  will-change: transform;\n}\n\n.apply-nursing-card h3 {\n  color: #c01313;\n  font-weight: 700;\n  margin-bottom: 10px;\n   display: inline-block;   /* keeps the box tight to the text */\n  padding: 0.25rem 0.6rem; /* space inside the border */\n  border: 1px solid #333;  /* border color/width */\n  border-radius: 999px;\n}\n\n.apply-nursing-card p {\n  color: #333;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.apply-nursing-card:hover {\n  background: #c01313;\n  color: #fff;\n  transform: translateY(-5px);\n  box-shadow: 0 6px 15px rgba(192, 19, 19, 0.4);\n}\n\n.apply-nursing-card:hover h3,\n.apply-nursing-card:hover p {\n  color: #fff;\n}\n\n/* ✅ Non-clickable cards (Step 2 & Step 3) */\n.apply-nursing-card--static {\n  cursor: default;\n}\n\n/* ✅ Floating animation for Step 2 & Step 3 */\n@keyframes gentleFloat {\n  0% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-6px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.apply-nursing-card--float {\n  animation: gentleFloat 4.2s ease-in-out infinite;\n}\n\n/* small stagger so both don't move in sync */\n.apply-nursing-card--float-delay {\n  animation-delay: 0.6s;\n}\n\n/* Keep hover behavior working even while floating */\n.apply-nursing-card--float:hover {\n  animation-play-state: paused;\n}\n\n/* === Note === */\n.apply-nursing-note {\n  margin-top: 40px;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.9);\n  border-left: 5px solid #fe0000;\n  padding: 16px;\n  border-radius: 10px;\n  font-weight: 500;\n  color: #333;\n}\n\n/* === Responsive === */\n@media (max-width: 768px) {\n  .apply-nursing-page {\n    padding-top: 100px;\n  }\n\n  .apply-nursing-container {\n    padding: 30px 20px;\n  }\n\n  .apply-nursing-title {\n    font-size: 1.8rem;\n  }\n\n  .apply-nursing-card {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
